import React from "react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { useConfig } from "@/lib/useConfig";

export function PublicLayout({ children }) {
  const { data: config } = useConfig();
  return (
    <div className="flex min-h-screen flex-col ss-grain">
      <a
        href="#kandungan-utama"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-xl focus:bg-card focus:px-4 focus:py-2 focus:text-sm focus:font-semibold"
      >
        Langkau ke kandungan utama
      </a>
      <SiteHeader config={config} />
      <main id="kandungan-utama" className="flex-1">
        {typeof children === "function" ? children(config) : children}
      </main>
      <SiteFooter config={config} />
    </div>
  );
}

export function PageHero({ eyebrow, title, description, children, testId }) {
  return (
    <section className="border-b border-border bg-card/60" data-testid={testId}>
      <div className="ss-container py-12 sm:py-16">
        {eyebrow && <p className="ss-eyebrow">{eyebrow}</p>}
        <h1 className="ss-h2 mt-3 max-w-3xl">{title}</h1>
        {description && <p className="ss-body mt-4 max-w-[68ch]">{description}</p>}
        {children}
      </div>
    </section>
  );
}

export function Loading({ label = "Memuatkan…", testId = "loading-state" }) {
  return (
    <div
      className="ss-container flex min-h-[60vh] flex-col items-center justify-center py-20 text-center"
      data-testid={testId}
      aria-live="polite"
    >
      <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-[hsl(var(--primary))] border-t-transparent" />
      <p className="mt-4 text-sm text-[hsl(var(--muted-foreground))]">{label}</p>
    </div>
  );
}

export function ErrorState({ message, onRetry, testId = "error-state" }) {
  return (
    <div className="ss-container py-16" data-testid={testId} role="alert">
      <div className="ss-card mx-auto max-w-lg p-6 text-center">
        <p className="text-sm font-medium">
          {message ||
            "Maaf, berlaku gangguan sementara. Cuba lagi sebentar."}
        </p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-4 rounded-xl bg-[hsl(var(--primary))] px-4 py-2 text-sm font-semibold text-white"
            data-testid="error-retry-button"
          >
            Cuba lagi
          </button>
        )}
      </div>
    </div>
  );
}
